//////////////////////////////////////////////////////////////////
// Helper function
//////////////////////////////////////////////////////////////////


function midpoint(touches: any): { x: number; y: number } {
  let [t1, t2] = touches;
  return {
    x: (t1.clientX + t2.clientX) / 2,
    y: (t1.clientY + t2.clientY) / 2,
  };
}

function distance(touches: any) {
  let [t1, t2] = touches;
  return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
}

type Gesture = {
  scale: number;
  translation: {
    x: number;
    y: number;
  };
  origin: {
    x: number;
    y: number;
  };
  type: GestureType;
};

enum GestureType {
  zoom,
  move,
  undefined,
}

export default class Zoomer {
  static mp_last: { x: number; y: number } | undefined;
  static mp_init: { x: number; y: number } | undefined;
  static type: GestureType;

  static initialD = 1;
  static lastD = 1;
  static eventCount = 0;

  static touchMove(e: any): Gesture | undefined {
    if (e.touches.length === 1 && Zoomer.mp_init && Zoomer.mp_last) {
      Zoomer.eventCount++;

      let mp_curr = { x: e.touches[0].clientX, y: e.touches[0].clientY };

      const dx = mp_curr.x - (Zoomer.mp_last?.x || mp_curr.x);
      const dy = mp_curr.y - (Zoomer.mp_last?.y || mp_curr.y);

      Zoomer.mp_last = { ...mp_curr };

      const touch_gesture = {
        scale: 1,
        translation: {
          x: dx,
          y: dy,
        },
        origin: Zoomer.mp_init,
        type: GestureType.undefined,
      };
      return touch_gesture;
    } else if (e.touches.length === 2 && Zoomer.mp_init && Zoomer.mp_last) {
      Zoomer.eventCount++;

      let mp_curr = midpoint(e.touches);

      const currentD = distance(e.touches);
      const scale = currentD / Zoomer.lastD;
      const scaleTotal = currentD / Zoomer.initialD;

      const dx = mp_curr.x - (Zoomer.mp_last?.x || mp_curr.x);
      const dy = mp_curr.y - (Zoomer.mp_last?.y || mp_curr.y);

      const dxTotal = mp_curr.x - (Zoomer.mp_init?.x || mp_curr.x);
      const dyTotal = mp_curr.y - (Zoomer.mp_init?.y || mp_curr.y);

      const touch_gesture = {
        scale: scale,
        translation: {
          x: dx,
          y: dy,
        },
        origin: Zoomer.mp_init,
        type: GestureType.move,
      };

      Zoomer.mp_last = { ...mp_curr };
      Zoomer.lastD = currentD;

      e.preventDefault();

      if (Zoomer.type == GestureType.undefined) {
        if (scaleTotal < 0.8 || scaleTotal > 1.2) {
          Zoomer.type = GestureType.zoom;
        } else if (Math.abs(dxTotal) > 30 || Math.abs(dyTotal) > 30) {
          Zoomer.type = GestureType.move;
        }
      }
      touch_gesture.type = Zoomer.type;

      //
      // Skip first Events for stable behaviour
      //

      if (Zoomer.eventCount > 3) {
        //
        // Solange noch kein Type festgelegt wurde behandeln wir es wie Move
        if (touch_gesture.type == GestureType.move || touch_gesture.type == GestureType.undefined) {
          touch_gesture.scale = 1;
        } else {
          touch_gesture.translation = { x: 0, y: 0 };
        }

        return touch_gesture;
      }
    }
  }

  static touchStart(e: any) {
    Zoomer.type = GestureType.undefined;
    Zoomer.eventCount = 0;
    if (e.touches.length === 2) {
      Zoomer.initialD = distance(e.touches);
      Zoomer.mp_last = midpoint(e.touches);
      Zoomer.mp_init = midpoint(e.touches);
    } else if (e.touches.length === 1) {
      Zoomer.initialD = 0;
      Zoomer.mp_last = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      Zoomer.mp_init = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }
  }
}
